module.exports = __webpack_public_path__ + "img/cooperative0_logo13.feb8251d.jpg";